<header class="gc-email-widget-header header bc-panel row-flex-container column-flex-fix"
        [ngClass]="{ expanded: isExpandedMode }">

  <div class="visitor-avatar avatar">
    <svg-icon icon="mail-open"></svg-icon>
  </div>

  <div class="visitor-name row-flex-grow">
    <ng-container *ngIf="isProactiveEmail">
      <span data-automation-id="gc-email-header-name" class="gc-email-display-name gc-text-bold" title="{{ 'genesysEmailWidgetHeader.newMessage' | translate }}">
        {{ 'genesysEmailWidgetHeader.newMessage' | translate }}
      </span>
    </ng-container>
    <ng-container *ngIf="externalContactFullName && !isProactiveEmail; else normalNameTpl">
      <div data-automation-id="gc-email-header-name" class="gc-email-display-name sender-name gc-text-bold">{{ externalContactFullName }}</div>
    </ng-container>
    <ng-template #normalNameTpl>
      <div data-automation-id="gc-email-header-name" class="gc-email-display-name sender-name gc-text-bold">{{ name }}</div>
    </ng-template>
  </div>

  <app-genesys-widget-header-tools [isExpandedMode]="isExpandedMode"
                                   [integrations]="integrations"
                                   [openIntegrationPanels]="openIntegrationPanels"
                                   (minimize)="minimize.emit()"
                                   (toggleExpanded)="toggleExpanded.emit()"
                                   (toggleIntegration)="toggleIntegration.emit($event)">
  </app-genesys-widget-header-tools>

</header>
